export const baseGambitFields = [
  'id',
  'start',
  'end',
  'gambitCategory',
  'gambitType',
  'timed',
  'streamed',
  'distance',
  'clubId',
  'club',
  'ownerId',
  'repeat',
  'parentId',
  'location',
  'title',
  'locationImageBlobHash',
  'canEdit',
  'attendeeCount',
  'minEloRating',
  'maxEloRating',
  'isAttending',
  'location',
  'timezone',
  'isChallenge',
  'isConfirmed',
  'isEditedChallenge',
  'isSpark',
  'invitations',
  'hasUnreadChatMessages',
];

export const detailGambitFields = [
  'id',
  'start',
  'end',
  'chessSetPolicy',
  'attendeeCount',
  'attendeeChessSetCount',
  'locationHasChessSets',
  'locationChessSetCount',
  'gambitType',
  'gambitCategory',
  'streamed',
  'timed',
  'description',
  'invitation',
  'invitations',
  'distance',
  'locationImageBlobHash',
  'createdAt',
  'updatedAt',
  'ownerId',
  'club',
  'repeat',
  'parentId',
  'location',
  'locationId',
  'title',
  'canEdit',
  'minEloRating',
  'maxEloRating',
  'isAttending',
  'attendees',
  'attendeeCount',
  'timezone',
  'futureRecurrences',

  'isChallenge',
  'isSpark',
  'isJoinable',
  'isConfirmed',
  'isEditedChallenge',

  'chat',
  'chatId',

  'activeCheckIns',
  'handshakeEligibleCheckIns',
  'recentCheckIns',

  'handshakes',
  'pendingHandshakes',

  'city',
  'cityId',

  'maxAttendees',
  'minConfirmations',
  'sparkOverlaps',
  'proposal',
  'isUnreadSuccessConfirmation',
  'hasChatMessages',
  'hasUnreadChatMessages',
  'unreadChatMessagesCount',
];

export const adminGambitFields = [
  'id',
  'start',
  'end',
  'gambitCategory',
  'createdAt',
  'updatedAt',
  'city',
  'location',
  'title',
  'minEloRating',
  'maxEloRating',
  'attendees',
  'attendeeCount',
  'timezone',
  'isConfirmed',
  'minConfirmations',
  'maxAttendees',
  'cityId',
  'locationId',
];
